// New script
function runAt(selector, callback) {
    const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }
  
  function getSelectors() {
    const dropdownContainer = document.querySelector(
      ".product-property__colorType"
    );
    const buttonsContainer = document.querySelector(
      ".product-property__colorShade"
    );
    const originalColorDropdown = document.querySelector(
      ".mw-options-container .mw-option:first-child select"
    );
    const originalColorShadeDropdown = document.querySelector(
      ".mw-options-container .mw-option:nth-child(2) select"
    );
  
    if (!originalColorDropdown && dropdownContainer) {
      dropdownContainer.style.display = "none";
    }
  
    if (!originalColorShadeDropdown && buttonsContainer) {
      buttonsContainer.style.display = "none";
    }
  
    return {
      originalColorDropdown,
      originalColorShadeDropdown,
      dropdownContainer,
      buttonsContainer,
      selected: dropdownContainer?.querySelector(
        ".property-colortype_dropdownSelected"
      ),
      customDropdown: dropdownContainer?.querySelector(
        ".property-colortype_dropdown"
      ),
      optionsContainer: dropdownContainer?.querySelector(
        ".property_dropdownOptions"
      ),
      shadeOptionsContainer: buttonsContainer?.querySelector(
        ".property-colorShade_buttons"
      ),
    };
  } 
  
  function colourHTML() {
    return `
        <div class="product-info__property-picker">
          <div class="product-property__colorType product-property_container">
            <span class="product-property_label">${window.color.color_heading}</span>
            <button class="property-colortype_dropdown">
              <div class="property-colortype_dropdownSelected">${window.color.color_placeholder}</div>
              <div class="dropdown_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                  <g clip-path="url(#clip0_2320_682)">
                      <path d="M7.71835 2.96969L4.4986 6.18944L1.27885 2.96969C1.13739 2.83307 0.947943 2.75747 0.751296 2.75918C0.554648 2.76089 0.366539 2.83977 0.227482 2.97882C0.0884264 3.11788 0.00954967 3.30599 0.00784085 3.50264C0.00613204 3.69929 0.0817278 3.88874 0.218346 4.03019L3.96835 7.78019C4.10899 7.92079 4.29972 7.99978 4.4986 7.99978C4.69747 7.99978 4.8882 7.92079 5.02885 7.78019L8.77885 4.03019C8.85048 3.961 8.90762 3.87825 8.94692 3.78674C8.98623 3.69524 9.00692 3.59682 9.00778 3.49724C9.00865 3.39766 8.98967 3.2989 8.95196 3.20672C8.91425 3.11455 8.85856 3.03081 8.78814 2.96039C8.71772 2.88997 8.63398 2.83428 8.54181 2.79657C8.44964 2.75886 8.35088 2.73989 8.2513 2.74075C8.15171 2.74162 8.0533 2.76231 7.96179 2.80161C7.87029 2.84092 7.78753 2.89806 7.71835 2.96969Z" fill="black"/>
                  </g>
                  <defs>
                      <clipPath id="clip0_2320_682">
                      <rect width="9" height="9" fill="white" transform="translate(0 0.5)"/>
                      </clipPath>
                  </defs>
               </svg>
              </div>
            </button>
            <div class="property_dropdownOptions"></div>
            <div class="property_dropdownError">${window.color.color_required}</div>
          </div>
          <div class="product-property__colorShade product-property_container">
            <span class="product-property_label">Glanzgrad wählen:</span>
            <div class="property-colorShade_buttons"></div>
            <div class="property_dropdownError">${window.color.color_required}</div>
          </div>
        </div>
      `;
  }
  
  function colorData() {
    const selectors = getSelectors();
  
    if (selectors.customDropdown) {
      selectors.customDropdown.addEventListener("click", (e) => {
        e.stopPropagation();
        selectors.dropdownContainer.classList.toggle("show");
      });
    }
  
    const prodId = document.querySelector(
      '.product-info__buy-buttons input[name="product-id"]'
    );
    let prodIdValue = prodId ? prodId.value : "";
    if (!prodIdValue) return;
  
    fetch(
      `https://apps.mageworx.com/app/productoptions/config/hamburgerlackprofi.myshopify.com_1774983780/${prodIdValue}.js`
    )
      .then((res) => res.json())
      .then((data) => {
        const optionsArray = Object.values(data.options || {});
        if (optionsArray.length < 1) return;
  
        const colorValueOptions = optionsArray[0]?.values
          ? Object.values(optionsArray[0].values)
          : [];
        const colorShadeOptions = optionsArray[1]?.values
          ? Object.values(optionsArray[1].values)
          : [];
  
        if (selectors.optionsContainer) {
          selectors.optionsContainer.innerHTML = "";
          colorValueOptions.forEach((option) => {
            const optionEle = document.createElement("button");
            optionEle.className = "color-option";
            optionEle.textContent = option.title;
            optionEle.dataset.value = option.title;
  
            const optionImageUrl = option.images?.length
              ? option.images[0].url
              : "https://cdn.shopify.com/s/files/1/0068/9219/1844/files/ACC_FL_Product_27_001.png?v=1736493273";
            if (optionImageUrl) {
              const img = document.createElement("img");
              img.src = optionImageUrl;
              img.alt = option.title;
              optionEle.prepend(img);
            }
  
            selectors.optionsContainer.appendChild(optionEle);
          });
        }
  
        if (!selectors.originalColorShadeDropdown) {
          selectors.shadeOptionsContainer?.parentElement.classList.add("hide");
        } else if (selectors.shadeOptionsContainer) {
          selectors.shadeOptionsContainer.innerHTML = "";
          colorShadeOptions.forEach((shade) => {
            const optionEle = document.createElement("button");
            optionEle.className = "shadow_option";
            optionEle.textContent = shade.title;
            optionEle.dataset.value = shade.title;
            selectors.shadeOptionsContainer.appendChild(optionEle);
          });
  
          selectors.shadeOptionsContainer.addEventListener("click", (e) => {
            if (e.target.classList.contains("shadow_option")) {
              Array.from(e.target.parentElement.children).forEach((sibling) =>
                sibling.classList.remove("active")
              );
              e.target.classList.add("active");
              selectors.originalColorShadeDropdown.value = e.target.dataset.value;
              selectors.originalColorShadeDropdown.dispatchEvent(
                new Event("change")
              );
            }
          });
        }
  
        if (selectors.optionsContainer) {
          selectors.optionsContainer.addEventListener("click", (e) => {
            if (e.target.classList.contains("color-option")) {
              selectors.selected.innerHTML = e.target.innerHTML;
              selectors.originalColorDropdown.value = e.target.dataset.value;
              selectors.originalColorDropdown.dispatchEvent(new Event("change"));
              selectors.dropdownContainer.classList.remove("show");
            }
          });
        }
      })
      .catch((error) => console.error("Error fetching color data:", error));
  }
  
  function errorHandler(targetButton) {
    const selectors = getSelectors();
  
    // Color Type Error
    const isColorNotSelected =
      selectors.selected.textContent.includes("Bitte auswählen");
    if (selectors.dropdownContainer) {
      selectors.dropdownContainer.classList.toggle(
        "show_error",
        isColorNotSelected
      );
    }
  
    // Color Shade Error
    const shadeSelector = selectors.buttonsContainer;
    const customShade = shadeSelector.querySelector(".shadow_option");
    const activeShade = shadeSelector.querySelector(".shadow_option.active");
    let isShadeNotSelected = "";
    if (customShade !== null) {
      isShadeNotSelected = activeShade === null;
    }
    if (shadeSelector) {
      if (isShadeNotSelected) {
        shadeSelector.classList.add("show_error");
      } else {
        shadeSelector.classList.remove("show_error");
      }
    }
  
    if (!isColorNotSelected && !isShadeNotSelected) {
      targetButton.click();
      if (colorSelector) {
        colorSelector.classList.remove("show_error");
      }
      if (shadeSelector) {
        shadeSelector.classList.remove("show_error");
      }
    } else if (isShadeNotSelected === "") {
      targetButton.click();
    }
  }
  
  function globalFunction() {
    const variantPicker = document.querySelector(
      ".product-info .product-info__variant-picker"
    );
    if (variantPicker) {
      variantPicker.insertAdjacentHTML("beforebegin", this.colourHTML());
      this.colorData();
  
      // Button Click Error Handler
      const buyButton = document.querySelector(
        ".buy-buttons--multiple button.button"
      );
      const buyButtonCta = document.querySelector(
        ".product-info .product-info__buy-buttons .buy-buttons #mwAddToCart"
      );
      if (buyButtonCta) {
        buyButtonCta.addEventListener("click", () => {
          errorHandler(buyButtonCta);
        });
      }
      if (buyButton) {
        buyButton.addEventListener("click", () => {
          errorHandler(buyButton);
        });
      }
    }
  }
  function init() {
    runAt(
      '.product-info__buy-buttons .mw-product-options .mw-options-container input[name="properties[RAL Farbton]"]',
      globalFunction
    );
  }
  init();
  